import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputBase, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { useStyles } from './styles';

interface Props {
  value?: string;
  placeholder?: string;
  onSearch?: () => void;
  setTableData?: React.Dispatch<React.SetStateAction<any>>;
  data?: any[];
  filterFieldName?: string;
  clearOnPropsChange?: boolean;
}

const searchStyle = {
  height: '30px !important',
  fontSize: '13px !important',
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '.MuiInputBase-root': {
    fontSize: '13px !important',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#B0BEC5',
  },
};

const InputSearch: React.FC<Props> = ({
  placeholder,
  setTableData = () => {},
  data = [],
  filterFieldName,
  clearOnPropsChange = true,
}) => {
  const { root, inputSearch, icon, altericon } = useStyles();
  const [value, setValue] = useState<string>('');

  // eslint-disable-next-line no-shadow
  const isValidDate = (value: string) => !isNaN(Date.parse(value));

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
  };

  const matchesSearch = (fieldValue: any, searchValue: string) => {
    if (fieldValue === null || fieldValue === undefined) return false;

    const fieldString = fieldValue.toString();

    if (isValidDate(fieldString)) {
      const formattedDate = formatDate(fieldString);
      return formattedDate.includes(searchValue);
    }

    return fieldString.toLowerCase().includes(searchValue.toLowerCase());
  };

  const requestSearch = (searchValue: string) => {
    setValue(searchValue);

    const filteredRows = data.filter((row) =>
      Object.keys(row).some((key) => {
        const fieldValue = row[key];
        if (filterFieldName && key !== filterFieldName) return false;
        return matchesSearch(fieldValue, searchValue);
      }),
    );

    setTableData(filteredRows);
  };

  const clearSearch = () => {
    setTableData(data);
    setValue('');
  };

  useEffect(() => {
    if (data) {
      requestSearch(value);
    }
    if (clearOnPropsChange) {
      setValue('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Paper component="form" className={root}>
      <IconButton aria-label="search" disabled>
        <SearchIcon className={value ? altericon : icon} />
      </IconButton>
      <InputBase
        placeholder={placeholder}
        className={inputSearch}
        value={value}
        sx={searchStyle}
        type="text"
        onKeyPress={(e) => {
          if (e.key === 'Enter') e.preventDefault();
        }}
        onChange={(event) => requestSearch(event.target.value)}
        inputProps={{ 'aria-label': 'search' }}
      />
      {value && (
        <IconButton aria-label="clear" onClick={clearSearch}>
          <CloseIcon className={icon} />
        </IconButton>
      )}
    </Paper>
  );
};

export default InputSearch;
